module.exports = "https://bin.bnbstatic.com/_next/static/images/es2-24c2b37b1680bb86463eb91dc8cbdb13.jpg";